export default "__VITE_ASSET__Bl8YGHuk__"